import { configureStore } from '@reduxjs/toolkit'
import createSagaMiddleware from '@redux-saga/core'
import * as Sentry from '@sentry/react'
import rootSaga from '../saga'
import reducers, { RootActions } from '../reducers'
import ListUserSlice from '../reducers/userReducer'

const maskedString = (value?: string): string | undefined =>
  value ? '*****' : undefined

const sentryReduxEnhancer = Sentry.createReduxEnhancer({
  actionTransformer: (action: RootActions) => {
    // Transform the action to remove sensitive information
    if (action.type == ListUserSlice.actions.setPlayerToken.type) {
      return {
        ...action,
        payload: {
          ...action.payload,
          token: maskedString(action.payload.token),
          accessToken: maskedString(action.payload.accessToken),
        },
      }
    }
    return action
  },
  stateTransformer: (state: ReturnType<typeof reducers>) => {
    // Transform the state to remove sensitive information
    const transformedState = {
      ...state,
      user: {
        ...state.user,
        token: maskedString(state.user.token),
        accessToken: maskedString(state.user.accessToken),
      },
    }
    return transformedState
  },
})

const sagaMiddleWare = createSagaMiddleware()
const store = configureStore({
  reducer: reducers,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(sagaMiddleWare),
  enhancers: (getDefaultEnhancers) => {
    return getDefaultEnhancers().concat(sentryReduxEnhancer)
  },
})

sagaMiddleWare.run(rootSaga)

export default store
